<template>
    <div>
        <Layout>
            <template v-slot:title>
                <h1>Dashboard</h1>
            </template>
            <template v-slot:content>
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="card">
                            <div class="card-header d-flex align-items-center">
                                <div class="icon">
                                    <radio-icon size="1.5x"></radio-icon>
                                </div>

                                <div class="flex-1 pl-2">
                                    <h2 class="mb-0 font-weight-bold">Firebase Usage</h2>
                                </div>
                            </div>
                            <div class="card-body p-3">
                                <Loader v-if="isConnectionLoading"></Loader>
                                <div class="d-lg-flex">
                                    <div class="mb-5 mb-lg-0 pr-lg-4" style="min-width: 250px">
                                        <div class="socket-number-container">
                                            <div :class="{ 'mb-2': true }" v-for="(item, index) in dataConnection" :key="`${index}`">
                                                <div v-if="index == 'connection'" :class="{ 'bg-connection': isConnection == 'connection' }" style="cursor: pointer;" @click="onConnection('connection')">
                                                    <p>Connections</p>
                                                    <span>
                                                        {{ item.length ? setMaxConnections(item) : 0 }}
                                                    </span>
                                                </div>
                                                <div v-if="index == 'storage'" :class="{ 'bg-connection': isConnection == 'storage' }" style="cursor: pointer;" @click="onConnection('storage')">
                                                    <p>Storage</p>
                                                    <span>
                                                        {{ item.length ? fileSizeReadable(parseFloat(item[0].value)) : 0 }}
                                                    </span>
                                                </div>
                                                <div v-if="index == 'download'" :class="{ 'bg-connection': isConnection == 'download' }" style="cursor: pointer;" @click="onConnection('download')">
                                                    <p>Downloads</p>
                                                    <span>
                                                        {{ item.length ? setTotalDownloads(item) : 0 }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-1 w-100">
                                        <div class="d-flex" style="justify-content: flex-end;">
                                            <div style="margin-right: 4%;">
                                                <span
                                                    class="text-sm pt-1 d-inline-block"
                                                    v-if="conversionDateRange.filter(item => item).length"
                                                    >{{ dateRangeReadable(conversionDateRange) }}</span
                                                >
                                                <span v-else>Last {{ chartType.chart.day }} days</span>
                                            </div>
                                            <div class="text-center">
                                                <a
                                                    href="#"
                                                    @click.prevent="onFirebaseMonitorDateChange([])"
                                                    v-if="conversionDateRange.filter(item => item).length"
                                                >
                                                    <DeleteIcon class="text-gray" size="1x" />
                                                </a>
                                                <date-picker
                                                    v-else
                                                    @change="onFirebaseMonitorDateChange"
                                                    v-model="conversionDateRange"
                                                    range
                                                >
                                                    <template v-slot:input><span></span></template>
                                                </date-picker>
                                            </div>
                                        </div>
                                        <chart-line
                                            :loading="googleApi.loading"
                                            :is-connection="isConnection"
                                            :type="socketConnection.chart.type"
                                            :series-data="socketConnection.chart.data"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <div class="card">
                            <div class="stat-chart-header">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        Last {{ chartType.chart.day }} days
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <div v-for="(day, index) in chartDay" :key="`'day'-${index}`">
                                            <a
                                                href="javascript:void(0)"
                                                :value="day"
                                                class="dropdown-item"
                                                @click="selectDateRange(day)"
                                                >Last {{ day }} days</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="stat-line">
                                <StatLinesChart
                                    :chart-type="typeChart"
                                    :response-temp="responseTemp"
                                    :google-api="googleApi.list"
                                    :get-day="getChartDay()"
                                    :loading="googleApi.loading"
                                >
                                </StatLinesChart>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <div class="card chart-detail">
                            <div class="d-flex chrat-detail-header mt-2">
                                <div class="w-100">
                                    <h2 class="title" style="font-size: 1.2rem">GA - Conversions</h2>
                                </div>
                                <div class="w-100 text-right">
                                    <span
                                        class="text-sm pt-1 d-inline-block"
                                        v-if="conversionDateRange.filter(item => item).length"
                                        >{{ dateRangeReadable(conversionDateRange) }}</span
                                    >
                                    <span v-else>Last {{ chartType.chart.day }} days</span>
                                </div>
                                <div style="width: 20%" class="text-center">
                                    <a
                                        href="#"
                                        @click.prevent="onConversionDateChange([])"
                                        v-if="conversionDateRange.filter(item => item).length"
                                    >
                                        <DeleteIcon class="text-gray" size="1x" />
                                    </a>
                                    <date-picker
                                        v-else
                                        @change="onConversionDateChange"
                                        v-model="conversionDateRange"
                                        range
                                    >
                                        <template v-slot:input><span></span></template>
                                    </date-picker>
                                </div>
                            </div>
                            <conversion :conversion="conversion.list" :loading="conversion.loading"> </conversion>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <div class="card chart-detail">
                            <div class="d-flex chrat-detail-header mt-2">
                                <div class="w-100">
                                    <h2 class="title" style="font-size: 1.2rem">GA - Top Pages</h2>
                                </div>
                                <div class="w-100 text-right">
                                    <span
                                        class="text-sm pt-1 d-inline-block"
                                        v-if="topQuizDateRange.filter(item => item).length"
                                        >{{ dateRangeReadable(topQuizDateRange) }}</span
                                    >
                                    <span v-else>Last {{ chartType.chart.day }} days</span>
                                </div>
                                <div style="width: 20%" class="text-center">
                                    <a
                                        href="#"
                                        @click.prevent="onTopQuizDateChage([])"
                                        v-if="topQuizDateRange.filter(item => item).length"
                                    >
                                        <DeleteIcon class="text-gray" size="1x" />
                                    </a>
                                    <date-picker v-else @change="onTopQuizDateChage" v-model="topQuizDateRange" range>
                                        <template v-slot:input><span></span></template>
                                    </date-picker>
                                </div>
                            </div>
                            <top-pages :topQuizes="topQuizes" :loading="topQuizes.loading" :getDay="getChartDay()">
                            </top-pages>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="red" :loading="members.loading">
                            <template slot="icon">
                                <users-icon size="1.5x" class="custom-class"></users-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{
                                            members.type !== 'total' && members.type !== 'today'
                                                ? `New this ${members.type}`
                                                : ''
                                        }}
                                        {{ members.type === 'today' ? 'New today' : '' }}
                                        {{ members.type === 'total' ? 'Total' : '' }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: members.type === 'total' }"
                                            @click="onChangeTypeCountMembers('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: members.type === 'today' }"
                                            @click="onChangeTypeCountMembers('today')"
                                            >New today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: members.type === 'week' }"
                                            @click="onChangeTypeCountMembers('week')"
                                            >New this week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: members.type === 'month' }"
                                            @click="onChangeTypeCountMembers('month')"
                                            >New this month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">
                                <router-link
                                    tag="span"
                                    :to="{
                                        name: 'user.index'
                                    }"
                                    class="cursor-pointer"
                                    >Members</router-link
                                >
                            </template>
                            <template slot="total">
                                <h3 class="total-score mb-0 font-weight-bold d-inline-block">
                                    <router-link
                                        tag="span"
                                        :to="{
                                            name: 'user.index'
                                        }"
                                        content="See all member(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="cursor-pointer"
                                        >{{ kNumberFormat(members.amount) }}</router-link
                                    >
                                </h3>
                            </template>
                            <template slot="description">Total number of members</template>
                            <template slot="footer">
                                <div class="row">
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'user.index',
                                            query: {
                                                provider: 'facebook'
                                            }
                                        }"
                                        content="Facebook member(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <f-icon
                                                :icon="['fab', 'facebook']"
                                                style="width: 24px; height: 24px"
                                            ></f-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">
                                            {{ kNumberFormat(members.facebook_amount) }}
                                        </p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'user.index',
                                            query: {
                                                provider: 'gmail'
                                            }
                                        }"
                                        content="Gmail member(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <f-icon
                                                :icon="['fab', 'google']"
                                                style="width: 24px; height: 24px"
                                            ></f-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(members.google_amount) }}</p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'user.index',
                                            query: {
                                                provider: 'gmail'
                                            }
                                        }"
                                        content="Vipps member(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <vipps-icon style="width: 70px; height: 25px"></vipps-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(members.vipps_amount) }}</p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'user.index',
                                            query: {
                                                provider: 'normal'
                                            }
                                        }"
                                        content="Normal member(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <user-icon size="1.5x"></user-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(members.normal_amount) }}</p>
                                    </router-link>
                                </div>
                            </template>
                        </DashboardCard>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="blue" :loading="subscriptions.loading">
                            <template slot="icon">
                                <dollar-sign-icon size="1.5x" class="custom-class"></dollar-sign-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{
                                            subscriptions.type !== 'total' && subscriptions.type !== 'today'
                                                ? `New this ${subscriptions.type}`
                                                : ''
                                        }}
                                        {{ subscriptions.type === 'today' ? 'New today' : '' }}
                                        {{ subscriptions.type === 'total' ? 'Total' : '' }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: subscriptions.type === 'total' }"
                                            @click="onChangeTypeCountSubscriptions('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: subscriptions.type === 'today' }"
                                            @click="onChangeTypeCountSubscriptions('today')"
                                            >New today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: subscriptions.type === 'week' }"
                                            @click="onChangeTypeCountSubscriptions('week')"
                                            >New this week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: subscriptions.type === 'month' }"
                                            @click="onChangeTypeCountSubscriptions('month')"
                                            >New this month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">
                                <router-link
                                    tag="span"
                                    :to="{
                                        name: 'orders.index',
                                        params: {
                                            type: 'subscription'
                                        }
                                    }"
                                    class="cursor-pointer"
                                    >Subscriptions</router-link
                                >
                            </template>
                            <template slot="total">
                                <h3 class="total-score per-two mb-0 font-weight-bold d-inline-block">
                                    <router-link
                                        tag="span"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'subscription'
                                            },
                                            query: {
                                                onlyActive: true
                                            }
                                        }"
                                        content="See active subscriptions"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="cursor-pointer"
                                        >{{ kNumberFormat(subscriptions.active_amount) }}</router-link
                                    >
                                    <span>&nbsp;/&nbsp;</span>
                                    <router-link
                                        tag="span"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'subscription'
                                            }
                                        }"
                                        content="See all subscriptions"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="cursor-pointer"
                                        >{{ kNumberFormat(subscriptions.amount) }}</router-link
                                    >
                                </h3>
                            </template>
                            <template slot="description">Total active subscriptions</template>
                            <template slot="footer">
                                <div class="row">
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'subscription'
                                            },
                                            query: {
                                                method: 'paypal',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Subscribe by PayPal"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-6 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <f-icon
                                                :icon="['fab', 'paypal']"
                                                style="width: 24px; height: 24px"
                                            ></f-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">
                                            {{ kNumberFormat(subscriptions.paypal_amount) }}
                                        </p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'subscription'
                                            },
                                            query: {
                                                method: 'stripe-checkout',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Subscribe by Stripe"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-6 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <i class="fa fa-cc-stripe"></i>
                                        </div>
                                        <p class="mb-0 font-weight-bold">
                                            {{ kNumberFormat(subscriptions.stripe_amount) }}
                                        </p>
                                    </router-link>
                                </div>
                            </template>
                        </DashboardCard>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="green" :loading="hour24.loading">
                            <template slot="icon">
                                <dollar-sign-icon size="1.5x" class="custom-class"></dollar-sign-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{
                                            hour24.type !== 'total' && hour24.type !== 'today'
                                                ? `New this ${hour24.type}`
                                                : ''
                                        }}
                                        {{ hour24.type === 'today' ? 'New today' : '' }}
                                        {{ hour24.type === 'total' ? 'Total' : '' }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: hour24.type === 'total' }"
                                            @click="onChangeTypeCountHour24('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: hour24.type === 'today' }"
                                            @click="onChangeTypeCountHour24('today')"
                                            >New today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: hour24.type === 'week' }"
                                            @click="onChangeTypeCountHour24('week')"
                                            >New this week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: hour24.type === 'month' }"
                                            @click="onChangeTypeCountHour24('month')"
                                            >New this month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">
                                <router-link
                                    tag="span"
                                    :to="{
                                        name: 'orders.index',
                                        params: {
                                            type: 'buy-player'
                                        }
                                    }"
                                    class="cursor-pointer"
                                    >Buy Player</router-link
                                >
                            </template>
                            <template slot="total">
                                <h3 class="total-score per-two mb-0 font-weight-bold d-inline-block">
                                    <router-link
                                        tag="span"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            },
                                            query: {
                                                onlyActive: true
                                            }
                                        }"
                                        content="See active buy player(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="cursor-pointer"
                                        >{{ kNumberFormat(hour24.active_amount) }}</router-link
                                    >
                                    <span>&nbsp;/&nbsp;</span>
                                    <router-link
                                        tag="span"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            }
                                        }"
                                        content="See all buy player(s)"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="cursor-pointer"
                                        >{{ kNumberFormat(hour24.amount) }}</router-link
                                    >
                                </h3>
                            </template>
                            <template slot="description">Total buy this year</template>
                            <template slot="footer">
                                <div class="row">
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            },
                                            query: {
                                                method: 'paypal',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Buy player(s) by PayPal"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <f-icon
                                                :icon="['fab', 'paypal']"
                                                style="width: 24px; height: 24px"
                                            ></f-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(hour24.paypal_amount) }}</p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            },
                                            query: {
                                                method: 'credit',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Buy player(s) by Credit"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <i class="fas fa-coins" aria-hidden="true"></i>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(hour24.credit_amount) }}</p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            },
                                            query: {
                                                method: 'stripe-checkout',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Buy player(s) by Stripe"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <i class="fa fa-cc-stripe"></i>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(hour24.stripe_amount) }}</p>
                                    </router-link>
                                    <router-link
                                        tag="div"
                                        :to="{
                                            name: 'orders.index',
                                            params: {
                                                type: 'buy-player'
                                            },
                                            query: {
                                                method: 'vipps',
                                                onlyActive: false
                                            }
                                        }"
                                        content="Buy player(s) by Vipps"
                                        v-tippy="{ placement: 'bottom' }"
                                        class="col-3 cursor-pointer total-container"
                                    >
                                        <div class="icon-container">
                                            <vipps-icon style="width: 70px; height: 25px"></vipps-icon>
                                        </div>
                                        <p class="mb-0 font-weight-bold">{{ kNumberFormat(hour24.vipps_amount) }}</p>
                                    </router-link>
                                </div>
                            </template>
                        </DashboardCard>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="orange" :loading="playAlone.loading">
                            <template slot="icon">
                                <play-icon size="1.5x" class="custom-class"></play-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{ playAlone.type }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playAlone.type === 'total' }"
                                            @click="onChangeTypeCountPlayAlone('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playAlone.type === 'today' }"
                                            @click="onChangeTypeCountPlayAlone('today')"
                                            >Today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playAlone.type === 'week' }"
                                            @click="onChangeTypeCountPlayAlone('week')"
                                            >Week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playAlone.type === 'month' }"
                                            @click="onChangeTypeCountPlayAlone('month')"
                                            >Month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">Play Alone</template>
                            <template slot="total">
                                <h3 class="mb-0 font-weight-bold d-inline-block">
                                    {{ kNumberFormat(playAlone.amount) }}
                                </h3>
                            </template>
                            <template slot="description">Total number of play alone</template>
                        </DashboardCard>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="purple" :loading="playTogether.loading">
                            <template slot="icon">
                                <play-circle-icon size="1.5x" class="custom-class"></play-circle-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{ playTogether.type }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playTogether.type === 'total' }"
                                            @click="onChangeTypeCountPlayTogether('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playTogether.type === 'today' }"
                                            @click="onChangeTypeCountPlayTogether('today')"
                                            >Today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playTogether.type === 'week' }"
                                            @click="onChangeTypeCountPlayTogether('week')"
                                            >Week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: playTogether.type === 'month' }"
                                            @click="onChangeTypeCountPlayTogether('month')"
                                            >Month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">Play Live</template>
                            <template slot="total">
                                <h3 class="mb-0 font-weight-bold d-inline-block">
                                    {{ kNumberFormat(playTogether.amount) }}
                                </h3>
                            </template>
                            <template slot="description">Total number of play live</template>
                        </DashboardCard>
                    </div>

                    <div class="col-md-6 col-lg-4 mb-3">
                        <DashboardCard color="green-dark" :loading="userQuizesCreated.loading">
                            <template slot="icon">
                                <file-plus-icon size="1.5x" class="custom-class"></file-plus-icon>
                            </template>
                            <template slot="more">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{ userQuizesCreated.type }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizesCreated.type === 'total' }"
                                            @click="onChangeTypeCountUserQuizCreated('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizesCreated.type === 'today' }"
                                            @click="onChangeTypeCountUserQuizCreated('today')"
                                            >Today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizesCreated.type === 'week' }"
                                            @click="onChangeTypeCountUserQuizCreated('week')"
                                            >Week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizesCreated.type === 'month' }"
                                            @click="onChangeTypeCountUserQuizCreated('month')"
                                            >Month</a
                                        >
                                    </div>
                                </div>
                            </template>
                            <template slot="title">
                                <router-link
                                    tag="span"
                                    :to="{
                                        name: 'quizzes.user.index'
                                    }"
                                    class="cursor-pointer"
                                    >User Quizes Created</router-link
                                >
                            </template>
                            <template slot="total">
                                <h3 class="mb-0 font-weight-bold d-inline-block">
                                    {{ kNumberFormat(userQuizesCreated.amount) }}
                                </h3>
                            </template>
                            <template slot="description">Total number of user quizes created</template>
                        </DashboardCard>
                    </div>

                    <div class="col-lg-6 mb-3">
                        <div class="card">
                            <div class="card-header d-flex align-items-center">
                                <div class="icon icon-rank">
                                    <award-icon size="1.5x"></award-icon>
                                </div>

                                <div class="flex-1 pl-2">
                                    <h2 class="mb-0 font-weight-bold">
                                        <span>Admin Quizes</span>
                                    </h2>
                                    <p class="mb-0 text-muted">5 most popular</p>
                                </div>

                                <div class="btn-group align-self-start">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{ adminQuizes.type }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: adminQuizes.type === 'total' }"
                                            @click="onChangeTypePopularAdminQuiz('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: adminQuizes.type === 'today' }"
                                            @click="onChangeTypePopularAdminQuiz('today')"
                                            >Today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: adminQuizes.type === 'week' }"
                                            @click="onChangeTypePopularAdminQuiz('week')"
                                            >Week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: adminQuizes.type === 'month' }"
                                            @click="onChangeTypePopularAdminQuiz('month')"
                                            >Month</a
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <PopularList :list="adminQuizes.list" :loading="adminQuizes.loading" />
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                        <div class="card">
                            <div class="card-header d-flex align-items-center">
                                <div class="icon icon-rank">
                                    <award-icon size="1.5x"></award-icon>
                                </div>

                                <div class="flex-1 pl-2">
                                    <h2 class="mb-0 font-weight-bold">User Quizes</h2>
                                    <p class="mb-0 text-muted">5 most popular</p>
                                </div>

                                <div class="btn-group align-self-start">
                                    <button
                                        type="button"
                                        class="btn dropdown-toggle text-capitalize"
                                        data-toggle="dropdown"
                                        aria-expanded="true"
                                    >
                                        {{ userQuizes.type }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" role="menu" x-placement="bottom-end">
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizes.type === 'total' }"
                                            @click="onChangeTypePopularUserQuiz('total')"
                                            >Total</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizes.type === 'today' }"
                                            @click="onChangeTypePopularUserQuiz('today')"
                                            >Today</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizes.type === 'week' }"
                                            @click="onChangeTypePopularUserQuiz('week')"
                                            >Week</a
                                        >
                                        <a
                                            href="javascript:void(0)"
                                            class="dropdown-item"
                                            :class="{ active: userQuizes.type === 'month' }"
                                            @click="onChangeTypePopularUserQuiz('month')"
                                            >Month</a
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <PopularList :list="userQuizes.list" :loading="userQuizes.loading" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Layout>
    </div>
</template>

<script>
import helpers from '@/service/helpers'
import Layout from '@/components/Layout'
import DashboardCard from '@/components/dashboard/Card'
import Conversion from '@/components/quizzes/Conversion'
import PopularList from '@/components/dashboard/PopularList'
import {
    UserIcon,
    UsersIcon,
    DollarSignIcon,
    PlayIcon,
    PlayCircleIcon,
    FilePlusIcon,
    AwardIcon,
    RadioIcon,
    DeleteIcon
} from 'vue-feather-icons'
import axios from 'axios'
import API_URL from '@/router/api'
import ChartLine from '@/components/dashboard/ChartLine'
import VippsIcon from '@/components/icon/Vipps'
import StatLinesChart from '@/components/dashboard/StatLinesChart'
import TopPages from '@/components/dashboard/TopPages'
import DatePicker from 'vue2-datepicker'
import { format } from 'date-fns'
import helperMixin from '@/mixins/helper'
import Loader from '@/components/Loader'

export default {
    name: 'dashboard',

    mixins: [helperMixin],

    components: {
        Layout,
        UserIcon,
        UsersIcon,
        DashboardCard,
        DollarSignIcon,
        PlayIcon,
        PlayCircleIcon,
        FilePlusIcon,
        PopularList,
        AwardIcon,
        RadioIcon,
        ChartLine,
        VippsIcon,
        Conversion,
        StatLinesChart,
        TopPages,
        DatePicker,
        DeleteIcon,
        Loader
    },

    sockets: {
        current_connection(count) {
            this.socketConnection.current = count
        }
    },

    props: {
        chartDetail: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            chartType: {
                chart: {
                    day: 7
                }
            },
            dayToWeek: 'Week',
            chartDay: [7, 14, 28],
            chooseType: ['line', 'bar'],
            typeChart: 'line',
            members: {
                type: 'total',
                amount: 0,
                facebook_amount: 0,
                google_amount: 0,
                normal_amount: 0,
                vipps_amount: 0,
                loading: false
            },
            subscriptions: {
                type: 'total',
                amount: 0,
                active_amount: 0,
                paypal_amount: 0,
                stripe_amount: 0,
                loading: false
            },
            hour24: {
                type: 'total',
                amount: 0,
                active_amount: 0,
                paypal_amount: 0,
                credit_amount: 0,
                stripe_amount: 0,
                vipps_amount: 0,
                loading: false
            },
            playAlone: {
                type: 'total',
                amount: 0,
                loading: false
            },
            playTogether: {
                type: 'total',
                amount: 0,
                loading: false
            },
            userQuizesCreated: {
                type: 'total',
                amount: 0,
                loading: false
            },
            adminQuizes: {
                type: 'total',
                list: [],
                loading: false
            },
            userQuizes: {
                type: 'total',
                list: [],
                loading: false
            },
            socketConnection: {
                current: 0,
                chart: {
                    type: 'today',
                    data: [],
                    total: 0,
                    interval: null
                }
            },
            googleApi: {
                list: [],
                loading: true
            },
            canRunApi: true,
            responseTemp: [],
            conversion: {
                list: [],
                loading: true
            },
            conversionDateRange: [],
            topQuizes: {
                list: [],
                loading: true
            },
            topQuizDateRange: [],
            axiosSource: axios.CancelToken.source(),
            cancelRequest: null,
            dataConnection: {
                connection: [
                    {
                        value: 0
                    }
                ],
                storage: [
                    {
                        value: 0
                    }
                ],
                download: [
                    {
                        value: 0
                    }
                ]
            },
            isConnection: 'connection',
            isConnectionLoading: true
        }
    },

    mounted() {
        this.fetchCountMembers()
        this.fetchCountUserQuizCreated()
        this.fetchPopularAminQuiz()
        this.fetchPopularUserQuiz()
        this.fetchCountCountSubscriptions()
        this.fetchCountHour24()
        this.fetchCountPlayAlone()
        this.fetchCountPlayTogether()

        this.getGoogleApi()
        this.callApiTopQuizes()
        this.callApiConversion()
        this.getFirebaseMonitor()

        this.cancelRequest = { cancel: this.axiosSource.cancel }
    },

    async beforeRouteLeave(to, from, next) {
        await this.cancelRequest.cancel()

        this.$nextTick(() => {
            next()
        })
    },

    destroyed() {
        if (
            typeof this.socketConnection.chart.interval !== 'undefined' &&
            this.socketConnection.chart.interval != null
        ) {
            clearInterval(this.socketConnection.chart.interval)
        }
    },

    methods: {
        ...helpers,

        onConnection(type) {
            this.isConnection = type

            let chart = []
            let total = 0

            for (let i in this.dataConnection[type]) {
                if (typeof this.dataConnection[type][i].date === 'undefined') {
                    continue
                }

                let hours = parseInt(this.dataConnection[type][i].value)
                let d = new Date(`${this.createdAt(this.dataConnection[type][i].date.$date.$numberLong)}`).getMonth()
                let m = new Date(`${this.createdAt(this.dataConnection[type][i].date.$date.$numberLong)}`).getDate()
                let y = new Date(`${this.createdAt(this.dataConnection[type][i].date.$date.$numberLong)}`).getFullYear()

                total += hours

                chart = [
                    ...chart,
                    {
                        x: new Date(Date.UTC(y, m, (d + 1))).getTime(),
                        y: type == 'connection' ? hours : (hours / 1024).toFixed(2)
                    }
                ]
            }

            this.socketConnection.chart.data = chart
            this.socketConnection.chart.total = total
        },

        setTotalDownloads(data) {
            let value = 0

            for (let index in data) {
                value = value + parseFloat(data[index].value)
            }

            return this.fileSizeReadable(value)
        },

        setMaxConnections(data) {
            let value = 0

            for (let index in data) {
                if (data[index].value > value) {
                    value = parseInt(data[index].value)
                }
            }

            return value;
        },

        async onFirebaseMonitorDateChange(value) {
            const dateFormat = 'yyyy-MM-dd'
            let [start, end] = value
            let dateRange = 6

            if (start && end) {
                dateRange = `${format(start, dateFormat)}_${format(end, dateFormat)}`
            }

            await this.getFirebaseMonitor(dateRange)
            this.conversion.loading = false
            this.conversionDateRange = value
        },

        createdAt(date) {
            return format(new Date(parseFloat(date)), 'dd.MM.yy HH:mm')
        },

        async getFirebaseMonitor(dateRange) {
            this.isConnectionLoading = true

            const QUERY_DATE = this.chartType.chart.day
            let range = QUERY_DATE

            if (dateRange) {
                range = dateRange
            }

            const url = `${API_URL.dashboard.firebaseMonitorConnection}?q=${range}`

            axios.get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    let chart = []
                    let dataConnection = []
                    let total = 0

                    for (let index in data) {
                        if (index == 'connection') {
                            dataConnection = data[index]
                        }
                    }

                    for (let i in dataConnection) {
                        let hours = parseInt(dataConnection[i].value)
                        let d = new Date(`${this.createdAt(dataConnection[i].date.$date.$numberLong)}`).getMonth()
                        let m = new Date(`${this.createdAt(dataConnection[i].date.$date.$numberLong)}`).getDate()
                        let y = new Date(`${this.createdAt(dataConnection[i].date.$date.$numberLong)}`).getFullYear()

                        total += hours

                        chart = [
                            ...chart,
                            {
                                x: new Date(Date.UTC(y, m, (d + 1))).getTime(),
                                y: hours
                            }
                        ]
                    }

                    this.isConnection = 'connection'
                    this.dataConnection = typeof data.length == 'undefined' ? (data.connection.length ? data : {
                        connection: [{value: 0}],
                        storage: [{value: 0}],
                        download: [{value: 0}]
                    }) : {
                        connection: [{value: 0}],
                        storage: [{value: 0}],
                        download: [{value: 0}]
                    }

                    this.socketConnection.chart.data = chart
                    this.socketConnection.chart.total = total
                    this.isConnectionLoading = false
                })
                .catch(() => {
                    this.isConnectionLoading = false
                })
        },

        async getGoogleApi(day = 7, callApi = false) {
            let response = this.canRunApi || callApi ? await this.callApi(day) : false
            if (!response) return

            for (let i = 0; i < response[0].data.data.rows.length; i++) {
                response[0].data.data.rows[i].timestamp = response[0].data.data.rows[i].timestamp * 1000
                response[1].data.data.rows[i].timestamp = response[0].data.data.rows[i].timestamp
            }

            this.googleApi.list = response
            this.googleApi.loading = false
            this.switchDay(day)
            return response || new Error('There might be some error')
        },

        callApi(day) {
            return new Promise(async (resolve, reject) => {
                const QUERY_DATE = day
                const url = axios.get(`${API_URL.googleApi.getVisitByDate}?q=${QUERY_DATE}`, {
                    cancelToken: this.axiosSource.token
                })
                const compareUrl = axios.get(`${API_URL.googleApi.getVisitCompare}?q=${QUERY_DATE}`, {
                    cancelToken: this.axiosSource.token
                })

                resolve(
                    await axios.all([url, compareUrl]).then(
                        axios.spread((...res) => {
                            return this.doubleCheckError(res)
                                ? res
                                : reject(err => Error(err, 'Check query of url api again'))
                        })
                    )
                )
            })
        },

        async callApiTopQuizes(dateRange) {
            this.topQuizes.loading = true

            const QUERY_DATE = this.chartType.chart.day
            let range = QUERY_DATE

            if (dateRange) {
                range = dateRange
            }

            try {
                const url = await axios.get(`${API_URL.googleApi.getTopQuizes}?q=${range}`, {
                    cancelToken: this.axiosSource.token
                })
                this.doubleCheckError(url) ? url : new Error('Check query of url api again')

                const rows = url.data.data.rows || []
                this.topQuizes.list = await this.converToTitle(rows)
            } catch {
                this.topQuizes.loading = false
            }
        },

        async callApiConversion(dateRange) {
            this.conversion.loading = true

            const QUERY_DATE = this.chartType.chart.day
            let range = QUERY_DATE

            if (dateRange) {
                range = dateRange
            }

            try {
                const url = await axios.get(`${API_URL.googleApi.getConversion}?q=${range}`, {
                    cancelToken: this.axiosSource.token
                })
                this.doubleCheckError(url) ? url : new Error('Check query of url api again')

                const defaultRows = {
                    CreateQuiz: 0,
                    PlayAlone: 0,
                    PlayLive: 0,
                    Register: 0
                }

                let rows = url.data.data.rows || []

                rows.forEach(row => {
                    let [key, value] = row
                    defaultRows[key] = parseInt(value)
                })
                rows = []
                let sumNumber = 0
                let keyName = ''

                for (let key in defaultRows) {
                    keyName = 'Payed'

                    if (key.indexOf('Payed_') > -1) {
                        sumNumber = sumNumber + defaultRows[key]
                    }

                    if (key != 'QuizLanding' && key.indexOf('Payed_') == -1) {
                        rows.push([key, defaultRows[key]])
                    }
                }
                rows.push([keyName, sumNumber])

                const users = ['Users', url.data.data.totalsForAllResults['ga:users']]

                rows.unshift(users)
                this.conversion.list = rows
                this.conversion.loading = false
            } catch {
                this.conversion.loading = false
                this.googleApi.loading = false
            }
        },

        converToTitle(arr) {
            let response = []

            arr.forEach(i => {
                let splitTitle = i[0].split('/')
                let title = splitTitle[splitTitle.length - 1]
                let cutFirst = title.slice(1)
                let bigFirst = title.charAt(0).toUpperCase()
                let meargeText = bigFirst + cutFirst.replace(/-/g, ' ')

                if (meargeText.indexOf('?') > -1) meargeText = meargeText.slice(0, meargeText.indexOf('?'))

                response.push({
                    title: i[4] ? i[4] : meargeText,
                    visited: Number(i[1]),
                    id: i[2],
                    quizCreateType: i[3],
                    quizTitle: i[4]
                })
            })

            this.topQuizes.loading = false
            return response
        },

        doubleCheckError(arr) {
            const errorMessage = '400'
            const temp = arr
            for (let i = 0; i < temp.length; i++) {
                if (typeof temp[i].data == 'string') {
                    const foundError = temp[i].data.includes(errorMessage)
                    console.log('foundError', temp[i].data.includes(errorMessage))
                    if (foundError) return false
                }
            }
            return true
        },

        deconstruct() {
            let result = []
            const temp = this.googleApi.list

            for (let i in this.googleApi.list) {
                result.push(temp[i].data.data.rows)
            }

            this.responseTemp = result
        },

        getChartDay() {
            var day = this.chartType.chart.day
            return day
        },

        setTypeChart(value) {
            return (this.typeChart = value)
        },

        selectDateRange(day) {
            this.googleApi.loading = true
            this.getGoogleApi(day, true)

            this.canRunApi = true
            this.callApiTopQuizes(day)
            this.callApiConversion(day)
        },

        switchDay(value) {
            this.chartType.chart.day = value
            this.deconstruct(value)

            if (!this.canRunApi) {
                this.callApiTopQuizes()
                this.callApiConversion()
            }

            this.canRunApi = false
            if (value === 7) this.dayToWeek = 'Week'
            else this.dayToWeek = `${this.chartType.chart.day} Days`
        },

        fetchCountMembers() {
            const self = this
            const url = `${API_URL.dashboard.members}?q=${self.members.type}`

            self.members.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data
                    self.members.amount = data.total
                    self.members.facebook_amount = data.total_facebook
                    self.members.google_amount = data.total_google
                    self.members.vipps_amount = data.total_vipps
                    self.members.normal_amount = data.total_normal
                    self.members.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountMembers(type) {
            this.members.type = type
            this.fetchCountMembers()
        },

        fetchCountUserQuizCreated() {
            const self = this
            const url = `${API_URL.dashboard.userQuizCreated}?q=${self.userQuizesCreated.type}`

            self.userQuizesCreated.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.userQuizesCreated.amount = data.total
                    self.userQuizesCreated.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountUserQuizCreated(type) {
            this.userQuizesCreated.type = type

            this.fetchCountUserQuizCreated()
        },

        fetchCountCountSubscriptions() {
            const self = this
            const url = `${API_URL.dashboard.subscriptions}?q=${self.subscriptions.type}`

            self.subscriptions.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.subscriptions.amount = data.total
                    self.subscriptions.active_amount = data.active
                    self.subscriptions.paypal_amount = data.paypal
                    self.subscriptions.stripe_amount = data.stripe
                    self.subscriptions.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountSubscriptions(type) {
            this.subscriptions.type = type

            this.fetchCountCountSubscriptions()
        },

        fetchCountHour24() {
            const self = this
            const url = `${API_URL.dashboard.hour24}?q=${self.hour24.type}`

            self.hour24.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.hour24.amount = data.total
                    self.hour24.active_amount = data.active
                    self.hour24.paypal_amount = data.paypal
                    self.hour24.credit_amount = data.credit
                    self.hour24.stripe_amount = data.stripe
                    self.hour24.vipps_amount = data.vipps
                    self.hour24.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountHour24(type) {
            this.hour24.type = type

            this.fetchCountHour24()
        },

        fetchCountPlayAlone() {
            const self = this
            const url = `${API_URL.dashboard.playAlone}?q=${self.playAlone.type}`

            self.playAlone.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.playAlone.amount = data.total
                    self.playAlone.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountPlayAlone(type) {
            this.playAlone.type = type

            this.fetchCountPlayAlone()
        },

        fetchCountPlayTogether() {
            const self = this
            const url = `${API_URL.dashboard.playTogether}?q=${self.playTogether.type}`

            self.playTogether.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.playTogether.amount = data.total
                    self.playTogether.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypeCountPlayTogether(type) {
            this.playTogether.type = type

            this.fetchCountPlayTogether()
        },

        fetchPopularAminQuiz() {
            const self = this
            const url = `${API_URL.dashboard.popularAdminQuiz}?q=${self.adminQuizes.type}`

            self.adminQuizes.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.adminQuizes.list = data
                    self.adminQuizes.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypePopularAdminQuiz(type) {
            this.adminQuizes.type = type

            this.fetchPopularAminQuiz()
        },

        fetchPopularUserQuiz() {
            const self = this
            const url = `${API_URL.dashboard.popularUserQuiz}?q=${self.userQuizes.type}`

            self.userQuizes.loading = true
            axios
                .get(url, { cancelToken: this.axiosSource.token })
                .then(res => {
                    const data = res.data.data

                    self.userQuizes.list = data
                    self.userQuizes.loading = false
                })
                .catch(err => {
                    console.log(err)
                })
        },

        onChangeTypePopularUserQuiz(type) {
            this.userQuizes.type = type

            this.fetchPopularUserQuiz()
        },

        dateRangeReadable(value, defaultText) {
            let [start, end] = value

            if (!start || !end) {
                return defaultText
            }

            return format(start, 'dd/MM-yyyy') + ' - ' + format(end, 'dd/MM-yyyy')
        },

        async onConversionDateChange(value) {
            const dateFormat = 'yyyy-MM-dd'
            let [start, end] = value
            let dateRange = 6

            if (start && end) {
                dateRange = `${format(start, dateFormat)}_${format(end, dateFormat)}`
            }

            await this.callApiConversion(dateRange)
            this.conversion.loading = false
            this.conversionDateRange = value
        },

        async onTopQuizDateChage(value) {
            const dateFormat = 'yyyy-MM-dd'
            let [start, end] = value
            let dateRange = 6

            if (start && end) {
                dateRange = `${format(start, dateFormat)}_${format(end, dateFormat)}`
            }

            await this.callApiTopQuizes(dateRange)
            this.topQuizes.loading = false
            this.topQuizDateRange = value
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/variable.scss';

.btn {
    &.dropdown-toggle {
        padding: 0 !important;
        min-width: auto !important;
        position: relative;
        padding-right: 0.75rem !important;
        color: #888;

        &::after {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            margin-left: 0;
        }

        & ~ .dropdown-menu {
            border-color: #eeeeee;

            .dropdown-item.active,
            .dropdown-item:active {
                background-color: var(--color-primary);
            }

            .dropdown-item:focus {
                outline: none;
            }
        }
    }
}

.card {
    height: 100%;

    .card-header {
        .icon {
            $color: $color-primary;
            --color: #{$color};
            --color-overlay: #{rgba($color, 0.1)};

            &.icon-rank {
                $color: #ffc800;
                --color: #{$color};
                --color-overlay: #{rgba($color, 0.1)};
            }

            width: 2.5rem;
            height: 2.5rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: var(--color);
            background-color: var(--color-overlay);
        }

        h2 {
            font-size: 1.2rem;
        }

        &::after {
            display: none;
        }
    }

    .card-body {
        @media (max-width: 575px) {
            padding: 0.5rem 0;
        }
    }

    .card-footer {
        .icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            min-height: 30px;
        }

        .total-container {
            display: flex;
            text-align: center;
            flex-direction: column;
            justify-content: space-between;
            transform: scale(1);
            padding: 7.5px;
            filter: drop-shadow(0 0 0 var(--color));
            transition: filter 0.15s, transform 0.15s;
            transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);

            &:hover {
                transform: scale(1.1);
                filter: drop-shadow(0 0 15px var(--color));
            }
        }
    }
}

.socket-number-container {
    width: 100%;
    height: auto;
    background-image: linear-gradient(20deg, rgba(#f77695, 0.2), rgba(#7568f0, 0.2));
    border-radius: 1rem;
    padding: 10px;
    text-align: center;

    p {
        margin-bottom: 3px;
    }

    span {
        color: rgb(174, 176, 179);
        font-weight: bold;
    }

    .bg-connection {
        $color: $color-primary;
        --color: #{$color};
        --color-overlay: #{rgba($color, 0.1)};

        background-color: var(--color-overlay);
        border-radius: 0.5rem;

        span {
            font-weight: bold;
            cursor: pointer;
            color: var(--color);
        }
    }
}


.fa-cc-stripe,
.fa-coins {
    font-size: 1.35em;
}

.total-score {
    cursor: default;
    font-size: 1.75rem;

    &.per-two {
        font-size: 1.5rem;
        padding-top: 0.25rem;
    }

    span {
        &.cursor-pointer:hover {
            color: var(--color);
            text-decoration: underline;
        }
    }
}
.flex {
    display: flex;
    justify-content: space-between;
}

.stat-chart {
    justify-content: center;
    flex-direction: row;
    text-align: left;
}

.stat-chart-col {
    justify-content: center;
    flex-direction: column;
    border-top: 1.5px solid #ebecf0;
    padding-top: 0.5rem;
    transition: border-top 0.25s ease-in;

    div,
    span {
        pointer-events: none;
    }

    &:hover {
        background-color: #fafafa;
    }
}

.chart-detail {
    padding: 0.5rem 1.25rem;

    strong {
        font-size: 20px;
        font-weight: bold;
    }

    .chrat-detail-header {
        margin-bottom: 2rem;
    }
}

.stat-chart-header {
    text-align: end;
    margin-top: 0.25rem;
    font-size: 25px;

    p {
        margin-right: 0.15rem;
        margin-bottom: 0rem;
    }

    .btn.dropdown-toggle {
        margin-right: 0.5rem;
    }

    .dropdown-toggle::after {
        transition: 0.2s ease-in;
        transform: rotate(90deg);
    }

    .btn-group.show {
        .dropdown-toggle::after {
            transition: 0.2s ease-in;
            transform: rotate(0deg);
        }
    }

    .dropdown-item:active {
        background-color: transparent !important;
        color: black;
    }
}

hr {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
}

.flex-08 {
    flex: 0.8;
}

.font-size-10 {
    font-size: 10px;
}

.font-size-12 {
    font-size: 12px;
}

.mr-6 {
    margin-right: 3rem;
}

.tab-select {
    border-color: #ebecf0;
    border-top-width: 1px;

    &.active {
        border-color: rgb(0, 126, 255);
        border-top-width: 4.5px;
    }
}

.justify-content-normal {
    justify-content: normal;
}
</style>
